import type {Annotation,Anchor,ContentPackage} from './types';

export function reanchorCandidates(note:Annotation,content:ContentPackage):Anchor[]{
 if(!note.anchor.exactQuote||note.anchor.fragments&&note.anchor.fragments.length>1)return [];
 const {language,exactQuote}=note.anchor;
 return content.blocks.flatMap(block=>{
  const text=language==='en'?block.enText:block.ruText;
  const found:Anchor[]=[];
  for(let start=text.indexOf(exactQuote);start!==-1;start=text.indexOf(exactQuote,start+1)){
   const end=start+exactQuote.length;
   found.push({blockId:block.id,language,start,end,exactQuote,prefix:text.slice(Math.max(0,start-32),start),suffix:text.slice(end,end+32),textHash:block.textHash,status:'resolved'});
  }
  return found;
 });
}

export function reanchorAnnotation(note:Annotation,candidate:Anchor,content:ContentPackage):Annotation{
 const verified=reanchorCandidates(note,content).find(a=>a.blockId===candidate.blockId&&a.start===candidate.start&&a.end===candidate.end&&a.language===candidate.language&&a.exactQuote===candidate.exactQuote);
 if(!verified)throw Error('Выбранный фрагмент больше не совпадает с исходной цитатой.');
 const block=content.blocks.find(b=>b.id===verified.blockId)!;
 return {...note,contentVersion:content.contentVersion,anchor:verified,sourceRefs:block.sourceRefs};
}

export function reanchorFragments(note:Annotation,candidates:Anchor[],content:ContentPackage):Annotation{
 const originals=note.anchor.fragments;
 if(!originals||originals.length<2||candidates.length!==originals.length)throw Error('Выберите совпадение для каждого фрагмента.');
 const fragments=originals.map((anchor,i)=>reanchorAnnotation({...note,anchor},candidates[i],content).anchor);
 for(let i=1;i<fragments.length;i++){
  const prev=fragments[i-1],next=fragments[i];
  const before=content.blocks.findIndex(b=>b.id===prev.blockId),after=content.blocks.findIndex(b=>b.id===next.blockId);
  if(after<before||fragments.slice(0,i).some(a=>a.blockId===next.blockId&&a.language===next.language&&next.start<a.end))throw Error('Фрагменты должны следовать в порядке текста и не перекрываться.');
 }
 const refs=fragments.flatMap(a=>content.blocks.find(b=>b.id===a.blockId)!.sourceRefs);
 return {...note,contentVersion:content.contentVersion,anchor:{...fragments[0],exactQuote:note.anchor.exactQuote,fragments,status:'resolved'},sourceRefs:[...new Map(refs.map(r=>[JSON.stringify(r),r])).values()]};
}
